var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
export function configure(_a) {
    var _b = _a.fallbackLng, fallbackLng = _b === void 0 ? 'de' : _b, resources = _a.resources, _c = _a.languageDetectionOrder, languageDetectionOrder = _c === void 0 ? ['querystring', 'localStorage'] : _c, _d = _a.defaultNS, defaultNS = _d === void 0 ? 'common' : _d, initCallback = _a.initCallback, overrides = _a.overrides;
    i18next
        .use(LanguageDetector)
        .use(initReactI18next)
        .init(__assign({ defaultNS: defaultNS, fallbackLng: fallbackLng, resources: resources, interpolation: {
            escapeValue: false,
        }, detection: {
            order: languageDetectionOrder,
            lookupQuerystring: 'language',
            caches: ['localStorage'],
        } }, overrides), initCallback);
    return i18next;
}
